const data = [
  {
    company: "Autodesk Asia",
    title: "Software Engineer Intern (Backend Developer)",
    date: "July 2022 - December 2022",
    works: [
      "Created a safeguard on SQL vulnerabilities, such as SQL injection and large input parameters on SpringBoot",
      "Escape security vulnerabilities by upgrading third-party dependencies",
      "Build a new pipeline architecture for Upchain’s microservices using Jenkins, Docker, Kubernetes, and AWS",
    ],
    offset: 0,
  },
  {
    company: "LionsBot International",
    date: "May 2022 - June 2022",
    title: "Software Engineer Intern (Mobile Developer)",
    works: [
      "Created the settings page by calling Web Socket and REST API using Flutter",
      "Tested all the UI features in order to be production ready",
      "Implemented Polymorphism, Inheritance, and Encapsulation design",
    ],
    offset: 1,
  },
];

export default data;
